module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-512x512-90134b455a2e89237290f2fa08d65003.png";